// extracted by mini-css-extract-plugin
export default {"row":"qrfj03RIQ244XIRIsuzy","walletMark":"eKYeXfLRF4MFeNrQUC14"};